import { BCKSInvitationCollectionPage } from 'app/BCKSPage/Invitation/collection'
import { isToggleEnabled } from 'configs/toggle-feature'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'

interface PropsInvitationCollectionPage {
  isKSSelectionEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const BCKSInvitationCollectionIndexPage = (
  props: PropsInvitationCollectionPage
) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <BCKSInvitationCollectionPage />
}

// eslint-disable-next-line react/display-name
BCKSInvitationCollectionIndexPage.Layout = ({ children }) => children

export default BCKSInvitationCollectionIndexPage
